import { CountryEntitie } from '../entities/country.entitie';
import { Mapper } from 'src/app/utilitis/base/mapper';
import { StorePublicEntitie } from '../entities/store-public.entitie';
import { MallPublicModel, StorePublicModel } from 'src/app/domain/models/store-public.model';
import { CountryModel } from 'src/app/domain/models/country.model';
import { MallPublicEntitie } from '../entities/mall-public.entitie';


export class MallPublicMapper extends Mapper<
MallPublicEntitie | MallPublicEntitie[],
MallPublicModel | MallPublicModel[]
> {
    mapperArrayFrom(payload: MallPublicEntitie[]): MallPublicModel[] {
        let data: MallPublicModel[] = [];
        payload.forEach((value: MallPublicEntitie) => {
            const dataConvert = this.mapperFrom(value);
            data.push(dataConvert);
        });
        return data;
    }

    mapperTo(payload: MallPublicModel): MallPublicEntitie {
        return {
            id: payload.id,
            name: payload.name,
        };
    }

    mapperFrom(payload: MallPublicEntitie): MallPublicModel {
        return {
            id: payload.id,
            name: payload.name,
        };
    }
}
